var _defs, _rect, _g, _g2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191,
    height: 56.306,
    viewBox: "0 0 191 56.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 6.614,
    x2: -0.383,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 17.098,
    x2: -1.305,
    y2: 17.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: 10.863,
    x2: -0.501,
    y2: 9.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 13.583,
    x2: 0.421,
    y2: 12.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(-13.593 -14.077)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 191,
    height: 56,
    rx: 5,
    transform: "translate(13.593 14.229)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(14.076 14.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M192.994,11.126a5.919,5.919,0,0,1,5.912,5.912V59.268a5.919,5.919,0,0,1-5.912,5.912H17.038a5.919,5.919,0,0,1-5.912-5.912V17.038a5.919,5.919,0,0,1,5.912-5.912H192.994m0-1.126H17.038A7.059,7.059,0,0,0,10,17.038V59.268a7.059,7.059,0,0,0,7.038,7.038H192.994a7.059,7.059,0,0,0,7.038-7.038V17.038A7.059,7.059,0,0,0,192.994,10Z",
    transform: "translate(-10 -10)",
    fill: "#a6a6a6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(72.286 23.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M59.891,21.62a3.813,3.813,0,0,1-1.049,2.82,4.093,4.093,0,0,1-3.1,1.25,4.35,4.35,0,0,1-4.388-4.412,4.35,4.35,0,0,1,4.388-4.412,4.372,4.372,0,0,1,1.734.353,3.474,3.474,0,0,1,1.32.945l-.742.742a2.857,2.857,0,0,0-2.313-1,3.266,3.266,0,0,0-3.28,3.373A3.322,3.322,0,0,0,58.1,23.709,2.663,2.663,0,0,0,58.807,22H55.74V20.983h4.093A3.6,3.6,0,0,1,59.891,21.62Z",
    transform: "translate(-51.352 -16.866)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M63.456,18.037H59.609v2.679h3.468V21.73H59.609v2.679h3.847v1.037H58.525V17h4.931Z",
    transform: "translate(-48.428 -16.811)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M66.277,25.446H65.19V18.037H62.832V17h5.8v1.037H66.277Z",
    transform: "translate(-46.672 -16.811)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M69.938,25.446V17h1.084v8.446Z",
    transform: "translate(-43.775 -16.811)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M75.126,25.446H74.04V18.037H71.681V17h5.8v1.037H75.126Z",
    transform: "translate(-43.065 -16.811)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M85.763,24.41a4.386,4.386,0,0,1-6.192,0,4.564,4.564,0,0,1,0-6.264,4.372,4.372,0,0,1,6.187.006,4.549,4.549,0,0,1,.006,6.258ZM80.371,23.7a3.249,3.249,0,0,0,4.589,0,3.306,3.306,0,0,0,.939-2.424,3.306,3.306,0,0,0-.939-2.424,3.249,3.249,0,0,0-4.589,0,3.31,3.31,0,0,0-.937,2.424A3.31,3.31,0,0,0,80.371,23.7Z",
    transform: "translate(-40.356 -16.866)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M85.575,25.446V17H86.9L91,23.569h.046L91,21.942V17h1.085v8.446H90.955L86.66,18.557h-.046l.046,1.629v5.26Z",
    transform: "translate(-37.401 -16.811)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M89.181,33.67a5.987,5.987,0,1,0,6.009,5.987A5.9,5.9,0,0,0,89.181,33.67Zm0,9.614a3.637,3.637,0,1,1,3.378-3.628A3.464,3.464,0,0,1,89.181,43.284ZM76.071,33.67a5.987,5.987,0,1,0,6.009,5.987A5.9,5.9,0,0,0,76.071,33.67Zm0,9.614a3.637,3.637,0,1,1,3.378-3.628A3.464,3.464,0,0,1,76.071,43.284Zm-15.6-7.777v2.539h6.077a5.3,5.3,0,0,1-1.382,3.2,6.222,6.222,0,0,1-4.695,1.86,6.758,6.758,0,0,1,0-13.515,6.475,6.475,0,0,1,4.58,1.814l1.792-1.792a8.862,8.862,0,0,0-6.372-2.563,9.3,9.3,0,1,0,0,18.6,8.5,8.5,0,0,0,6.485-2.608,8.392,8.392,0,0,0,2.2-5.942,8.2,8.2,0,0,0-.137-1.586Zm63.778,1.972a5.564,5.564,0,0,0-5.125-3.809,5.689,5.689,0,0,0-5.646,5.987,5.859,5.859,0,0,0,5.942,5.987,5.954,5.954,0,0,0,4.989-2.653l-2.041-1.361a3.42,3.42,0,0,1-2.948,1.655,3.047,3.047,0,0,1-2.9-1.813l8.005-3.312Zm-8.164,2a3.284,3.284,0,0,1,3.129-3.492,2.316,2.316,0,0,1,2.223,1.27Zm-6.508,5.805h2.629v-17.6h-2.629Zm-4.31-10.273h-.09a4.149,4.149,0,0,0-3.152-1.337,5.992,5.992,0,0,0,0,11.973,4.079,4.079,0,0,0,3.152-1.361h.09v.863c0,2.29-1.223,3.515-3.2,3.515a3.313,3.313,0,0,1-3.017-2.133l-2.29.953a5.7,5.7,0,0,0,5.307,3.537c3.084,0,5.693-1.814,5.693-6.236V34.032h-2.5Zm-3.015,8.277a3.641,3.641,0,0,1,0-7.256,3.374,3.374,0,0,1,3.2,3.651A3.344,3.344,0,0,1,102.257,43.284Zm34.32-15.6h-6.294v17.6h2.625V38.614h3.668a5.473,5.473,0,1,0,0-10.93Zm.068,8.481h-3.736V30.133h3.736a3.017,3.017,0,1,1,0,6.032Zm16.233-2.527a4.934,4.934,0,0,0-4.687,2.693l2.332.974a2.488,2.488,0,0,1,2.4-1.291,2.529,2.529,0,0,1,2.762,2.265v.18a5.81,5.81,0,0,0-2.739-.678c-2.513,0-5.072,1.381-5.072,3.961,0,2.355,2.061,3.872,4.369,3.872a3.706,3.706,0,0,0,3.352-1.722h.09v1.358h2.535V38.5C158.219,35.38,155.888,33.638,152.877,33.638Zm-.317,9.644c-.861,0-2.061-.429-2.061-1.494,0-1.358,1.494-1.879,2.784-1.879a4.686,4.686,0,0,1,2.4.588A3.184,3.184,0,0,1,152.56,43.281Zm14.9-9.26-3.011,7.629h-.09l-3.125-7.629H158.4l4.686,10.663-2.672,5.932h2.739l7.223-16.595ZM143.8,45.28h2.627v-17.6H143.8Z",
    transform: "translate(20.807 11.026)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(28.115 24.128)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M20.623,17.568a2.825,2.825,0,0,0-.65,1.978V50.677a2.823,2.823,0,0,0,.65,1.978l.1.1L38.167,35.317v-.411L20.728,17.465Z",
    transform: "translate(-19.973 -17.008)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M38.712,37.766,32.9,31.95v-.411l5.815-5.815.131.076,6.888,3.913c1.966,1.118,1.966,2.946,0,4.064L38.844,37.69Z",
    transform: "translate(-14.704 -13.641)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M43.924,35.947,37.979,30,20.435,47.545c.649.687,1.72.771,2.927.086L43.924,35.947",
    transform: "translate(-19.785 -11.898)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M43.924,29.3,23.362,17.614c-1.206-.686-2.278-.6-2.927.086L37.979,35.244Z",
    transform: "translate(-19.785 -17.14)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(0 23.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M43.794,34.132,23.362,45.741a2.344,2.344,0,0,1-2.821.015h0l-.106.1h0l.1.1h0a2.344,2.344,0,0,0,2.821-.015L43.924,34.263Z",
    transform: "translate(-19.785 -34.132)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M20.623,42.891a2.823,2.823,0,0,1-.65-1.978v.207a2.819,2.819,0,0,0,.65,1.976l.106-.1Z",
    transform: "translate(-19.973 -31.368)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M44.048,31.828l-7.019,3.988.131.131,6.888-3.913A2.471,2.471,0,0,0,45.523,30h0A2.619,2.619,0,0,1,44.048,31.828Z",
    transform: "translate(-13.02 -11.898)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M23.55,17.82,51,33.416a2.619,2.619,0,0,1,1.475,1.827h0A2.467,2.467,0,0,0,51,33.211L23.55,17.614c-1.968-1.118-3.577-.189-3.577,2.064v.207C19.973,17.631,21.582,16.7,23.55,17.82Z",
    transform: "translate(-19.973 -17.14)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleEn);
export default __webpack_public_path__ + "static/media/google-en.b3cd577c8ff92dc70a152e230a25fdfd.svg";
export { ForwardRef as ReactComponent };